import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { COOKIE_CONSENT_KEY, readCookieConsent } from '../../lib/cookieConsent';
import { initMatomo, isMatomoConfigured, trackMatomoPageView } from '../../lib/matomo';

export default function MatomoTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isMatomoConfigured()) return undefined;

    const startIfAllowed = () => {
      if (readCookieConsent() !== 'accepted') return;
      initMatomo();
    };

    startIfAllowed();

    const onStorage = (event) => {
      if (event.key === COOKIE_CONSENT_KEY && readCookieConsent() === 'accepted') {
        startIfAllowed();
      }
    };

    const onConsent = () => {
      if (readCookieConsent() === 'accepted') startIfAllowed();
    };

    window.addEventListener('storage', onStorage);
    window.addEventListener('sosvor-cookie-consent', onConsent);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('sosvor-cookie-consent', onConsent);
    };
  }, []);

  useEffect(() => {
    if (!isMatomoConfigured()) return;
    trackMatomoPageView(
      `${location.pathname}${location.search}`,
      document.title,
    );
  }, [location.pathname, location.search]);

  return null;
}
